import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { WhatsAppIcon } from "@/components/icons";
import { waLink } from "@/config/site";
import { track } from "@/lib/analytics";

export const CTASection = ({
  eyebrow = "NRI Property Services · Hyderabad",
  title = "Your Property Is in Hyderabad. You Don\u2019t Have to Be.",
  copy = "Whether you need a tenant, rent collection, property inspection, maintenance, cleaning, repairs, documentation or complete property management — we can coordinate it for you locally. Let us become your trusted presence in Hyderabad.",
}) => (
  <section className="bg-ivory py-20 sm:py-28">
    <div className="container-site">
      <Reveal>
        <div className="relative overflow-hidden rounded-[2rem] bg-navy-900 px-7 py-16 sm:px-14 sm:py-20 lg:px-20">
          <div
            className="pointer-events-none absolute inset-0"
            style={{ background: "radial-gradient(ellipse 55% 60% at 90% 10%, rgba(201,162,39,0.18), transparent 60%)" }}
            aria-hidden="true"
          />
          <div className="relative max-w-3xl">
            <div className="flex items-center gap-4">
              <span className="gold-rule" aria-hidden="true" />
              <span className="eyebrow">{eyebrow}</span>
            </div>
            <h2 className="mt-6 font-display text-4xl font-extrabold leading-[1.05] tracking-tight text-white sm:text-5xl">
              {title}
            </h2>
            <p className="mt-6 max-w-2xl text-base leading-relaxed text-white/65 sm:text-lg">{copy}</p>
            <div className="mt-10 flex flex-wrap gap-4">
              <Link to="/contact" className="btn-gold" data-testid="cta-section-assessment" onClick={() => track("assessment_request", { location: "cta_section" })}>
                Get Free Property Assessment <ArrowRight className="h-4 w-4" />
              </Link>
              <a href={waLink()} target="_blank" rel="noopener noreferrer" className="btn-ghost-light" data-testid="cta-section-whatsapp" onClick={() => track("whatsapp_click", { location: "cta_section" })}>
                <WhatsAppIcon className="h-4 w-4 text-[#25D366]" /> WhatsApp Us
              </a>
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
